module.exports = __webpack_public_path__ + "img/aixam.f95cf151.png";